<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 transition-opacity duration-300 animate-fade-in"
  [class.opacity-0]="!isVisible" [class.opacity-100]="isVisible" (click)="onClose()">

  <div
    class="bg-white dark:bg-slate-900/95 backdrop-blur-sm w-full max-w-4xl md:max-w-5xl rounded-[2rem] shadow-2xl overflow-hidden transition-all duration-300 relative text-slate-800 dark:text-slate-200 border border-slate-100/50 dark:border-slate-800/50"
    [class.translate-y-4]="!isVisible" [class.translate-y-0]="isVisible" (click)="$event.stopPropagation()">

    <!-- Backdrop Blob -->
    <!-- <div class="absolute top-10 right-10 w-44 h-44 bg-amber-400/10 rounded-full blur-3xl pointer-events-none -z-10">
    </div> -->

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800/80">
      <div class="flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.3)]">
          <span class="material-icons">add_alert</span>
        </div>
        <div>
          <h2 class="text-lg font-extrabold text-slate-900 dark:text-white">เปิดเคสแจ้งปัญหาใหม่</h2>
          <div class="flex items-center gap-2 mt-0.5">
            <span class="text-[10px] font-bold px-2 py-0.5 rounded-full"
              [ngClass]="currentStep() === 1 ? 'bg-amber-400/20 text-amber-600 dark:text-amber-400' : 'bg-slate-100 text-slate-400 dark:bg-slate-800'">
              Step 1: ค้นหาลูกค้า
            </span>
            <span class="material-icons text-slate-300 text-[10px]">chevron_right</span>
            <span class="text-[10px] font-bold px-2 py-0.5 rounded-full"
              [ngClass]="currentStep() === 2 ? 'bg-amber-400/20 text-amber-600 dark:text-amber-400' : 'bg-slate-100 text-slate-400 dark:bg-slate-800'">
              Step 2: ระบุปัญหา
            </span>
          </div>
        </div>
      </div>
      <button (click)="onClose()"
        class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors cursor-pointer border-none">
        <span class="material-icons text-sm">close</span>
      </button>
    </div>

    <!-- Modal Form Body -->
    <div class="p-6 space-y-5 max-h-[70vh] overflow-y-auto custom-scrollbar">

      <!-- ================= STEP 1: CUSTOMER SELECTION ================= -->
      <div *ngIf="currentStep() === 1" class="space-y-6 py-4 animate-fade-in">

        <div class="text-center mb-6">
          <div
            class="w-16 h-16 bg-amber-50 dark:bg-amber-900/20 rounded-full flex items-center justify-center mx-auto mb-3">
            <span class="material-icons text-amber-500 text-3xl">person_search</span>
          </div>
          <h3 class="text-sm font-bold text-slate-700 dark:text-slate-200">ค้นหาผู้ใช้บริการ LINE ที่แจ้งปัญหา</h3>
          <p class="text-xs text-slate-500 mt-1">กรุณาระบุชื่อ หรือเบอร์โทรศัพท์ เพื่อเชื่อมโยงเคสปัญหากับบัญชีลูกค้า
          </p>
        </div>

        <!-- User Verification Section -->
        <div class="max-w-lg mx-auto space-y-4">
          <div *ngIf="!userVerified"
            class="p-5 rounded-2xl bg-amber-50/50 dark:bg-amber-900/20 border border-amber-200/70 dark:border-amber-800/50 space-y-4">
            <h4 class="text-sm font-bold text-amber-700 dark:text-amber-400 flex items-center gap-2">
              <span class="material-icons text-base">verified_user</span>
              ยืนยันตัวตนผู้ใช้บริการ
            </h4>
            <div class="flex flex-col gap-3">
              <div
                class="flex rounded-xl bg-slate-50 dark:bg-slate-800 p-1 border border-slate-100 dark:border-slate-700 w-fit shrink-0 mx-auto sm:mx-0">
                <button type="button" (click)="verifySearchType = 'phone'"
                  class="px-5 py-1.5 rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
                  [ngClass]="verifySearchType === 'phone' ? 'bg-amber-400 text-white shadow-[0_4px_12px_rgba(251,191,36,0.35)]' : 'bg-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'">
                  เบอร์โทร
                </button>
                <button type="button" (click)="verifySearchType = 'lineid'"
                  class="px-5 py-1.5 rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
                  [ngClass]="verifySearchType === 'lineid' ? 'bg-amber-400 text-white shadow-[0_4px_12px_rgba(251,191,36,0.35)]' : 'bg-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'">
                  Line UID
                </button>
              </div>

              <div class="flex flex-col sm:flex-row gap-2">
                <div
                  class="relative flex-1 flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
                  <input type="text" [(ngModel)]="verifySearchText" (keyup.enter)="verifyUser()"
                    [placeholder]="verifySearchType === 'phone' ? 'ระบุเบอร์โทรศัพท์' : 'ระบุ Line UID'"
                    class="w-full pl-4 pr-10 bg-transparent border-none outline-none text-sm font-semibold text-slate-700 dark:text-slate-200" />
                  <button *ngIf="verifySearchText" (click)="verifySearchText = ''"
                    class="absolute right-2 p-1 text-slate-400 hover:text-slate-600 bg-transparent border-none cursor-pointer flex items-center justify-center">
                    <span class="material-icons text-[18px]">close</span>
                  </button>
                </div>
                <button type="button" (click)="verifyUser()" [disabled]="isVerifying"
                  class="h-[46px] px-6 rounded-xl bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:hover:bg-white text-white dark:text-slate-900 text-sm font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 cursor-pointer border-none shadow-lg shadow-slate-900/10 shrink-0">
                  <span class="material-icons text-sm" [class.animate-spin]="isVerifying">
                    {{ isVerifying ? 'sync' : 'search' }}
                  </span>
                  ตรวจสอบ
                </button>
              </div>
            </div>

            <!-- Candidate List -->
            <div *ngIf="showCandidateList && verifyCandidates.length > 0"
              class="mt-4 border-t border-amber-200/50 pt-4 animate-fade-in-up">
              <label class="text-xs font-bold text-amber-700/80 mb-2 block">พบผู้ใช้หลายรายการ กรุณาเลือก:</label>
              <div class="space-y-2 max-h-48 overflow-y-auto custom-scrollbar pr-1">
                <div *ngFor="let cand of verifyCandidates" (click)="selectVerifiedCandidate(cand)"
                  class="flex items-center justify-between p-3 rounded-xl bg-white/60 hover:bg-white dark:bg-slate-800/60 dark:hover:bg-slate-800 border border-transparent hover:border-amber-300 dark:hover:border-amber-500/50 cursor-pointer transition-all group shadow-sm">
                  <div class="flex items-center gap-3">
                    <div
                      class="w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 flex items-center justify-center">
                      <span class="material-icons text-sm">person</span>
                    </div>
                    <div>
                      <div
                        class="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
                        {{ cand.fullName || '-' }}
                      </div>
                      <div class="text-xs text-slate-500">โทร: {{ cand.phone || '-' }}</div>
                    </div>
                  </div>
                  <span
                    class="material-icons text-amber-400 opacity-0 group-hover:opacity-100 transition-opacity">chevron_right</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Verified State -->
          <div *ngIf="userVerified"
            class="p-5 rounded-2xl bg-emerald-50/50 dark:bg-emerald-900/20 border border-emerald-200/70 dark:border-emerald-800/50 flex items-center justify-between animate-fade-in">
            <div class="flex items-center gap-4">
              <div
                class="w-12 h-12 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-lg shadow-emerald-500/30">
                <span class="material-icons text-2xl">check_circle</span>
              </div>
              <div>
                <div class="text-xs font-bold text-emerald-600 dark:text-emerald-400 mb-0.5">ยืนยันตัวตนสำเร็จ</div>
                <div class="text-sm font-extrabold text-slate-800 dark:text-slate-100">{{ formData.contactName || '-' }}
                </div>
                <div class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">เบอร์โทร: {{ formData.contactPhone || '-'
                  }}</div>
              </div>
            </div>
            <button type="button" (click)="clearVerifiedUser()"
              class="px-4 py-2 rounded-xl bg-white dark:bg-slate-800 text-slate-500 hover:text-rose-500 dark:text-slate-400 dark:hover:text-rose-400 text-xs font-bold border border-slate-200 dark:border-slate-700 hover:border-rose-200 dark:hover:border-rose-900/50 shadow-sm transition-all cursor-pointer flex items-center gap-1">
              <span class="material-icons text-xs">refresh</span> ค้นหาใหม่
            </button>
          </div>
        </div>
      </div>

      <!-- ================= STEP 2: PROBLEM DETAILS ================= -->
      <div *ngIf="currentStep() === 2" class="space-y-5 animate-fade-in-up">

        <!-- Subject of Case -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            หัวข้อแจ้งปัญหา <span class="text-rose-500">*</span>
          </label>
          <div
            class="flex items-center  bg-slate-100/30 dark:bg-slate-800 shadow-inset rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-3 transition-all duration-300">
            <input type="text" [(ngModel)]="formData.subject"
              placeholder="เช่น ขอเงินคืนเนื่องจากชำระเงินซ้ำ, ปัญหาไม้กั้นไม่เปิด..."
              class="w-full text-xs font-semibold outline-none border-none  text-slate-700 dark:text-slate-200" />
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Issue Type Dropdown (Combobox) -->
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
              ประเภทเรื่องปัญหา <span class="text-rose-500">*</span>
            </label>
            <div class="relative">
              <div
                class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
                <input type="text" [(ngModel)]="searchIssueText" (focus)="isIssueDropdownOpen = true"
                  (blur)="closeIssueDropdown()" placeholder="เลือกประเภทเรื่อง..."
                  class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
                <button type="button" (click)="toggleIssueDropdown()"
                  class="bg-transparent border-none outline-none cursor-pointer flex items-center">
                  <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                    [class.rotate-180]="isIssueDropdownOpen">expand_more</span>
                </button>
              </div>

              <div *ngIf="isIssueDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up">
                <button *ngFor="let opt of filteredIssueTypes" (click)="selectIssueType(opt)"
                  class="w-full text-left px-4 py-2.5 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium">
                  {{ opt.name }} ({{ opt.code }})
                </button>
                <div *ngIf="filteredIssueTypes.length === 0"
                  class="py-3 text-center text-xs text-slate-400 font-medium">
                  ไม่พบประเภทเรื่องปัญหา
                </div>
              </div>
            </div>
          </div>

          <!-- Site Combobox -->
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ลานจอด
              (Site)</label>
            <div class="relative">
              <div
                class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
                <input type="text" [(ngModel)]="searchSiteText" (focus)="isSiteDropdownOpen = true"
                  (blur)="closeSiteDropdown()" placeholder="ไม่ผูกลานจอด"
                  class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
                <button type="button" (click)="toggleSiteDropdown()"
                  class="bg-transparent border-none outline-none cursor-pointer flex items-center">
                  <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                    [class.rotate-180]="isSiteDropdownOpen">expand_more</span>
                </button>
              </div>

              <div *ngIf="isSiteDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up">
                <button (click)="selectSite({ id: null, name: 'ไม่ผูกลานจอด' })"
                  class="w-full text-left px-4 py-2.5 text-xs text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 block transition-colors cursor-pointer border-none bg-transparent font-medium italic">
                  -- ไม่ผูกลานจอด --
                </button>
                <button *ngFor="let site of filteredSites" (click)="selectSite(site)"
                  class="w-full text-left px-4 py-2.5 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium">
                  {{ site.name }}
                </button>
                <div *ngIf="filteredSites.length === 0" class="py-3 text-center text-xs text-slate-400 font-medium">
                  ไม่พบข้อมูลลานจอด
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <!-- Channel Custom Dropdown -->
          <div class="space-y-2">
            <label
              class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ช่องทางรับแจ้ง</label>
            <div class="relative">
              <button type="button" (click)="toggleChannelDropdown()" (blur)="closeChannelDropdown()"
                class="w-full flex items-center justify-between bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus:ring-2 focus:ring-amber-200 px-4 py-2.5 transition-all duration-300 cursor-pointer">
                <span class="text-xs font-semibold text-slate-700 dark:text-slate-200">{{
                  channelLabels[formData.channel] }}</span>
                <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                  [class.rotate-180]="isChannelDropdownOpen">expand_more</span>
              </button>

              <div *ngIf="isChannelDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 overflow-hidden animate-fade-in-up">
                <button (click)="selectChannel('phone')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="material-icons text-slate-400 text-sm">phone</span> โทรศัพท์ (Phone)
                </button>
                <button (click)="selectChannel('walk_in')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="material-icons text-slate-400 text-sm">directions_walk</span> Walk-in
                </button>
                <button (click)="selectChannel('backoffice')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="material-icons text-slate-400 text-sm">computer</span> ระบบหลังบ้าน
                </button>
              </div>
            </div>
          </div>

          <!-- Priority Custom Dropdown -->
          <div class="space-y-2">
            <label
              class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ความสำคัญ</label>
            <div class="relative">
              <button type="button" (click)="togglePriorityDropdown()" (blur)="closePriorityDropdown()"
                class="w-full flex items-center justify-between bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus:ring-2 focus:ring-amber-200 px-4 py-2.5 transition-all duration-300 cursor-pointer">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full" [ngClass]="{
                          'bg-slate-400': formData.priority === 'low',
                          'bg-blue-400': formData.priority === 'normal',
                          'bg-orange-500 animate-pulse': formData.priority === 'high',
                          'bg-rose-500 animate-pulse': formData.priority === 'urgent'
                        }"></span>
                  <span class="text-xs font-semibold text-slate-700 dark:text-slate-200">{{
                    priorityLabels[formData.priority] }}</span>
                </div>
                <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                  [class.rotate-180]="isPriorityDropdownOpen">expand_more</span>
              </button>

              <div *ngIf="isPriorityDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 overflow-hidden animate-fade-in-up">
                <button (click)="selectPriority('low')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="w-2 h-2 rounded-full bg-slate-400"></span> ต่ำ (Low)
                </button>
                <button (click)="selectPriority('normal')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="w-2 h-2 rounded-full bg-blue-400"></span> ปกติ (Normal)
                </button>
                <button (click)="selectPriority('high')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="w-2 h-2 rounded-full bg-orange-500"></span> สูง (High)
                </button>
                <button (click)="selectPriority('urgent')"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-rose-50 dark:hover:bg-slate-700/50 transition-colors border-none bg-transparent font-medium flex items-center gap-2 cursor-pointer">
                  <span class="w-2 h-2 rounded-full bg-rose-500"></span> ด่วนที่สุด (Urgent)
                </button>
              </div>
            </div>
          </div>

          <!-- Assigned Staff (Combobox) -->
          <div class="space-y-2">
            <label
              class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">มอบหมายให้</label>
            <div class="relative">
              <div
                class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
                <input type="text" [(ngModel)]="searchStaffText" (focus)="isStaffDropdownOpen = true"
                  (blur)="closeStaffDropdown()" placeholder="เลือกเจ้าหน้าที่..."
                  class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
                <button type="button" (click)="toggleStaffDropdown()"
                  class="bg-transparent border-none outline-none cursor-pointer flex items-center">
                  <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                    [class.rotate-180]="isStaffDropdownOpen">expand_more</span>
                </button>
              </div>

              <div *ngIf="isStaffDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up">
                <button (click)="selectStaff({ id: 0, name: 'ยังไม่มอบหมาย' })"
                  class="w-full text-left px-4 py-2 text-xs hover:bg-slate-50 dark:hover:bg-slate-700/50 block transition-colors cursor-pointer border-none bg-transparent font-medium text-slate-400 italic">
                  -- ยังไม่มอบหมาย --
                </button>
                <button *ngFor="let s of filteredStaff" (click)="selectStaff(s)"
                  class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium">
                  {{ s.name }} ({{ s.username }})
                </button>
                <div *ngIf="filteredStaff.length === 0" class="py-3 text-center text-xs text-slate-400 font-medium">
                  ไม่พบเจ้าหน้าที่
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Override Contact Info -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="space-y-2">
            <label
              class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ชื่อผู้ติดต่อแจ้งเรื่อง
              (เปลี่ยนแปลงได้)</label>
            <div
              class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
              <input type="text" [(ngModel)]="formData.contactName" placeholder="ชื่อผู้ติดต่อ..."
                class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
            </div>
          </div>

          <div class="space-y-2">
            <label
              class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">เบอร์โทรศัพท์ติดต่อ
              (เปลี่ยนแปลงได้)</label>
            <div
              class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
              <input type="text" [(ngModel)]="formData.contactPhone" placeholder="เบอร์โทรติดต่อ..."
                class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
            </div>
          </div>
        </div>

        <!-- Description of issue -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            รายละเอียดและคำอธิบายปัญหา <span class="text-rose-500">*</span>
          </label>
          <textarea [(ngModel)]="formData.description" placeholder="กรอกรายละเอียดปัญหาทั้งหมดที่รับแจ้ง..." rows="4"
            class="w-full text-xs font-semibold bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus:ring-2 focus:ring-amber-200 p-3 outline-none transition-all duration-300 resize-none text-slate-750 dark:text-slate-200"></textarea>
        </div>

        <!-- Attach images (optional, removable before submit) -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            แนบรูปหลักฐาน (ถ้ามี)
          </label>
          <p class="text-[11px] text-slate-400">ลากวางหรือคลิกเลือก · หลายไฟล์ได้ · ลบได้ก่อนเปิดเคส · หลังบันทึกแล้วลบไม่ได้</p>

          <div
            class="relative rounded-2xl border-2 border-dashed transition-all duration-200 cursor-pointer"
            [ngClass]="isImageDragOver
              ? 'border-amber-400 bg-amber-50/70 dark:bg-amber-900/20'
              : 'border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 hover:border-amber-300 hover:bg-amber-50/40'"
            (dragenter)="onImageDragEnter($event)"
            (dragover)="onImageDragOver($event)"
            (dragleave)="onImageDragLeave($event)"
            (drop)="onImageDrop($event)"
            (click)="imageFileInput.click()">
            <input #imageFileInput type="file" accept="image/*" multiple (change)="onImagesSelected($event)"
              class="sr-only" />
            <div class="flex flex-col items-center justify-center gap-2 px-4 py-8 text-center pointer-events-none">
              <span class="material-icons text-3xl"
                [ngClass]="isImageDragOver ? 'text-amber-500' : 'text-slate-400'">
                {{ isImageDragOver ? 'file_download' : 'cloud_upload' }}
              </span>
              <p class="text-sm font-bold text-slate-600 dark:text-slate-300">
                {{ isImageDragOver ? 'วางรูปที่นี่' : 'ลากรูปมาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์' }}
              </p>
              <p class="text-[11px] text-slate-400">รองรับไฟล์รูปภาพเท่านั้น</p>
            </div>
          </div>

          <div *ngIf="pendingImages.length" class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2">
            <div *ngFor="let img of pendingImages; let i = index"
              class="relative aspect-square rounded-2xl overflow-hidden border border-amber-200">
              <img [src]="img.previewUrl" [alt]="img.fileName" class="w-full h-full object-cover" />
              <button type="button" (click)="removePendingImage(i)"
                class="absolute top-1 right-1 w-6 h-6 rounded-full bg-rose-500 text-white border-none cursor-pointer flex items-center justify-center p-0">
                <span class="material-icons text-[14px]">close</span>
              </button>
            </div>
          </div>
        </div>

      </div> <!-- End Step 2 -->

    </div>

    <!-- Modal Footer -->
    <div
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-800/80 flex items-center justify-between bg-slate-50/50 dark:bg-slate-900/50">

      <!-- Step 1 Footer -->
      <ng-container *ngIf="currentStep() === 1">
        <button (click)="onClose()"
          class="px-5 py-2.5 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 font-bold text-xs cursor-pointer transition-colors border-none bg-transparent">
          ยกเลิก
        </button>
        <button (click)="nextStep()"
          class="px-6 py-2.5 bg-slate-900 dark:bg-slate-100 hover:bg-slate-800 dark:hover:bg-white text-white dark:text-slate-900 font-bold rounded-2xl text-xs cursor-pointer transition-all duration-300 border-none flex items-center gap-2 shadow-lg">
          ถัดไป <span class="material-icons text-sm">arrow_forward</span>
        </button>
      </ng-container>

      <!-- Step 2 Footer -->
      <ng-container *ngIf="currentStep() === 2">
        <button (click)="prevStep()"
          class="px-5 py-2.5 rounded-2xl border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold text-xs cursor-pointer transition-colors bg-transparent flex items-center gap-1">
          <span class="material-icons text-sm">arrow_back</span> ย้อนกลับ
        </button>

        <div class="flex items-center gap-3">
          <button (click)="onClose()"
            class="px-5 py-2.5 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 font-bold text-sm cursor-pointer transition-colors border-none bg-transparent">
            ยกเลิก
          </button>
          <button (click)="onSave()" [disabled]="isSaving()"
            class="px-6 py-3.5 bg-amber-400 disabled:bg-slate-100 disabled:text-slate-400 hover:bg-amber-500 text-white font-black rounded-2xl text-sm cursor-pointer transition-all duration-300 hover:shadow-[0_8px_16px_-4px_rgba(251,191,36,0.5)] border-none flex items-center gap-1.5">
            <span *ngIf="isSaving()" class="material-icons text-sm animate-spin">sync</span>
            {{ isSaving() ? 'กำลังบันทึก...' : 'เปิดเคสแจ้งปัญหา' }}
          </button>
        </div>
      </ng-container>

    </div>

  </div>
</div>